import { Component, OnInit } from "@angular/core";
import { UserService } from "src/app/_service/user.service";
import { AlertifyService } from "src/app/_service/alertify.service";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "src/app/_models/user";

@Component({
  selector: "user-location",
  templateUrl: "./user-location.component.html",
  styleUrls: ["./user-location.component.css"]
})
export class UserLocationComponent implements OnInit {
  constructor(
    private userService: UserService,
    private alertify: AlertifyService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  user: User;

  model: any = {
    userId: null,
    authorityUnitId: null
  };

  authorities;
  level1Authorities;
  level2Authorities;
  level3Authorities;
  locations;
  selectedHospital: string;
  departmentCount: number;
  hideLevel3DropDown: boolean;

  public selectedAuthority: any;
  public selectedLevel1Authority: any;
  public selectedLevel2Authority: any;
  public selectedLevel3Authority: any;

  ngOnInit() {
    this.loadUser();
    this.getAuthorityNames();
  }


  getAuthorityNames() {
    return this.userService.getAuthorityNames().subscribe(res => {
      this.authorities = res;
    });
  }

onUserSelectAuthority() {
 this.getLevel1DropDown();
}

onUserSelectLevel1() {
  this.getLevel2DropDown();
}

onUserSelectLevel2() {
  this.getLevel3DropDown();
}

getLevel1DropDown() {
    return this.userService.levelDropDown(this.selectedAuthority).subscribe(res => {
      this.level1Authorities = res;
  });
}

getLevel2DropDown() {
    return this.userService.levelDropDown(this.selectedLevel1Authority).subscribe(res => {
      this.level2Authorities = res;
  });
}

getLevel3DropDown() {
    this.departmentCount = 0;
    if (this.departmentCount == 0) {
      this.hideLevel3DropDown = true;
    } 
    return this.userService.levelDropDown(this.selectedLevel2Authority).subscribe(res => {
      this.level3Authorities = res;
  });
}

  assignLocation() {
   if(this.selectedLevel3Authority == null) {
    this.model.authorityUnitId = this.selectedLevel2Authority;
   } 
   else {
    this.model.authorityUnitId = this.selectedLevel3Authority;
   }

    return this.userService.assignUserLocation(this.model).subscribe(res => {
      this.alertify.success(`User assigned a location`);
      this.locations = res;
    });
  }

  loadUser() {
    this.userService.getUser(this.route.snapshot.params["id"]).subscribe(
      (user: User) => {
        this.user = user;
      },
      error => {
        this.alertify.error(error);
      }
    );
  }
}